import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

/**
 *  ClassRecordTechniquesModel are the techniques practiced in a 
 * particular class.
 */
export class ClassRecordTechniquesModel {
	constructor(classRecordId) {
		this.ClassRecordId = classRecordId;
		this.techniques = new Array();
		this.Listeners = new signals.Signal();

		DojoDeshi.instance().RPC().LoadClassRecordTechniques(classRecordId)
		.then( 
			(res)=>{
				res[0].map( (t)=>this.addTechnique(t, false) );
			}, 
			(err)=>{
				alert("ERROR on LoadClassRecordTechniques:", err); 
			} );
	}
	count() {
		return this.techniques.length;
	}
	addTechnique(technique, addToServer=true) {
		if (addToServer) {
			DojoDeshi.instance().RPC().AddTechniqueToClassRecord(this.ClassRecordId, technique.Name)
			.then(
				(res)=>{
					technique.Id = res[0];
					this.techniques.push(technique);
					this.Listeners.dispatch('technique_added', technique);
				}, (err)=>{
					alert(err);
				});
		} else {
			this.techniques.push(technique);
			this.Listeners.dispatch('technique_added', technique);
		}

	}
	removeTechnique(technique, sendToServer=true) {
		if (sendToServer) {
			DojoDeshi.instance().RPC().RemoveTechniqueFromClassRecord(this.ClassRecordId, technique.Name)
			.then(
				(res)=> {
					_.remove(this.techniques, technique);
					this.Listeners.dispatch('technique_removed', technique);
				},
				(err)=> {
					alert(err);
				}
			);
		} else {
			console.log("Removed technique in MEMORY model only " , technique);
			this.techniques = _.remove(this.techniques, technique);
			this.Listeners.dispatch('technique_removed', technique);
		}
	}
}